import React, { useContext } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
// material
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// helpers
import { getTimeZoneDate, getTimeZoneGTM } from '../../../helpers/Util';
// context
import { ReportContext } from '../../../contexts/Report';

export default function AppLastOrdersList() {
  const [searchParams] = useSearchParams();

  const { sales, isLoading, hasError } = useContext(ReportContext);

  const getStatusColor = (status) => {
    switch (status) {
      case 'AUTHORIZED':
        return 'success';
      case 'PENDING':
        return 'warning';
      default:
        return 'error';
    }
  };

  const handleClickOrderRow = (orderId) => {
    window.location.href = `/order/${orderId}?eventId=${searchParams.get('eventId')}`;
  };

  if (hasError) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the last orders — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <>
      <Typography sx={{ mt: 4, mb: 2 }} variant="h6">
        Last Orders
      </Typography>

      {isLoading ? (
        <Typography align="center" variant="h3">
          <CircularProgress size={30} color="inherit" />
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 1060 }} size="small" aria-label="a dense table">
            <caption>
              <Button
                variant="outlined"
                to={`/order/list?eventId=${searchParams.get('eventId')}`}
                component={RouterLink}
              >
                See All
              </Button>
            </caption>
            <TableHead>
              <TableRow>
                <TableCell># Order Number</TableCell>
                <TableCell width="250">Order Date</TableCell>
                <TableCell width="90">Country</TableCell>
                <TableCell align="center">Tickets</TableCell>
                <TableCell width="170">Payment Status</TableCell>
                <TableCell width="160">Payment Method</TableCell>
                <TableCell width="140" align="right">
                  Total Amount
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sales.orders.recents.map((order) => (
                <TableRow
                  hover
                  key={order._id}
                  onClick={() => handleClickOrderRow(order.transaction.order._id)}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }}
                >
                  <TableCell component="th" scope="row">
                    {order.transaction.order.number}
                  </TableCell>
                  <TableCell>
                    {`${getTimeZoneDate({ date: order.transaction.order.createdAt })
                      .tz('Europe/Lisbon')
                      .format('ddd, DD MMM, HH:mm')}
                      (GTM${getTimeZoneGTM({ date: order.transaction.order.createdAt })})`}
                  </TableCell>
                  <TableCell>{order.transaction.location?.country?.code || '-'}</TableCell>
                  <TableCell align="center">{order.transaction.order.bookings.length}</TableCell>
                  <TableCell>
                    <Chip
                      label={order.transaction.status}
                      color={getStatusColor(order.transaction.status)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{order.transaction.payment.method || '-'}</TableCell>
                  <TableCell align="right">{`${order.transaction.amount.total} €`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
